import { REQUEST_UPDATE_MEDIA, RECIEVE_UPDATE_MEDIA } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { getBackendUrl } from '../env';


const requestUpdateMedia = (scene, sceneMediaID) => ({
    type: REQUEST_UPDATE_MEDIA,
    scene: scene,
    sceneMediaID: sceneMediaID
});

const recieveUpdateMedia = (scene, sceneMediaID) => ({
    type: RECIEVE_UPDATE_MEDIA,
    scene: scene,
    sceneMediaID: sceneMediaID
});
 
const canUpdateMedia = mediaItem => {
    return !mediaItem.updating;
};

export const updateMedia = (scene, sceneMediaID, updatePayload) => dispatch => {
    dispatch(requestUpdateMedia(scene, sceneMediaID));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}/media/${sceneMediaID}`, {method: 'PATCH', body: JSON.stringify(updatePayload), headers: { 'Content-Type': 'application/json' }})
        .then(getBody)
        .then(json => dispatch(recieveUpdateMedia(scene, json.sceneMediaID)));
};

export const updateMediaIfOK = (scene, sceneMediaID, updatePayload) => (dispatch, getState) => {
    const state = getState();
    const {mediaItems} = state.mediaByScene[scene];

    const itemToUpdate = mediaItems.find(item => item.sceneMediaID === sceneMediaID);

    if (itemToUpdate && canUpdateMedia(itemToUpdate)) {
        return dispatch(updateMedia(scene, sceneMediaID, updatePayload))
            .catch(err => {
                dispatch(recieveUpdateMedia);   // Recieve update handles cleanup
                dispatch(displayError(err));
            }
        );
    }
};



// WEBPACK FOOTER //
// ./src/actions/updateMedia.js